"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26805],{

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40922);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4024);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 80366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 99907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17812);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80366);





var DeleteModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, handleDeleteOkModal = param.handleDeleteOkModal, target = param.target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content modal-width-130",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: function() {
                                return closeModal();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-xl font-bold text-danger mb-0 mt-2",
                            id: "modal-title",
                            children: "해당 ".concat(target, " 삭제 하시겠습니까?")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs text-888 keep-words mt-2",
                            children: "삭제한 데이터는 복구가 불가능합니다."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-x w-2/3 py-3 font-bold",
                        onClick: function() {
                            return handleDeleteOkModal();
                        },
                        children: "삭제"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DeleteModal);


/***/ }),

/***/ 81268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5566);
/* harmony import */ var components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4534);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32692);





var MaterialModal = function(param) {
    var children = param.children, open = param.open, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "aria-labelledby": "spring-modal-title",
        "aria-describedby": "spring-modal-description",
        className: "popup-wrap",
        open: open,
        onClose: closeModal,
        closeAfterTransition: true,
        disableScrollLock: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        outline: 0,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: open,
            className: "center2",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialModal);


/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







/* Material-UI 모달 Fade */ var ModalFade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        config: {
            duration: 10
        },
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
ModalFade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFade);


/***/ }),

/***/ 49957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33426);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80366);






/* 신고하기 모달 */ var ReportModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, handleModalOkButton = param.handleModalOkButton, title = param.title, setTitle = param.setTitle, content = param.content, setContent = param.setContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content m-0 modal-width-180",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: "text-danger font-gmarket-medium text-2xl font-bold mb-4 center",
                    children: "신고하기"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "제목",
                                placeholder: "신고할 내용의 제목을 입력하세요",
                                fullWidth: true,
                                value: title,
                                onChange: function(e) {
                                    return setTitle(e.target.value);
                                },
                                margin: "normal",
                                InputLabelProps: {
                                    shrink: true
                                },
                                className: "mt-4 w-full"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full py-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "내용",
                                placeholder: "신고 내용을 입력하세요",
                                fullWidth: true,
                                value: content,
                                onChange: function(e) {
                                    return setContent(e.target.value);
                                },
                                multiline: true,
                                rows: 8,
                                className: "mt-4 w-full",
                                InputLabelProps: {
                                    shrink: true
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-x w-2/5",
                        onClick: function() {
                            return handleModalOkButton();
                        },
                        children: "보내기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReportModal);


/***/ }),

/***/ 43928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29802);





// 데이터 리스트
var SearchBar = react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .Search.SearchBar */ .ol.SearchBar, ClearSearchButton = react_bootstrap_table2_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .Search.ClearSearchButton */ .ol.ClearSearchButton;
function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
var SearchTable = function(param) {
    var props = param.props, size = param.size;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var field = document.getElementById("search-bar-0");
        if (field) {
            field.id = uuidv4();
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "col-12 search-area flex align-items-center justify-center mt-3 mt-xl-0 ".concat(size),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "ti-search pl-3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchBar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.searchProps), {
                className: "border-search-box"
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClearSearchButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.searchProps), {
                className: "clear-btn-2 mr-3"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchTable);


/***/ }),

/***/ 26805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ report; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-table-next/lib/index.js
var lib = __webpack_require__(99551);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-table2-paginator/lib/index.js
var react_bootstrap_table2_paginator_lib = __webpack_require__(814);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-table2-toolkit/lib/index.js
var react_bootstrap_table2_toolkit_lib = __webpack_require__(29802);
// EXTERNAL MODULE: ./stores/settings.js
var stores_settings = __webpack_require__(31806);
// EXTERNAL MODULE: ./components/FormatDate.js
var FormatDate = __webpack_require__(87936);
// EXTERNAL MODULE: ./components/Alert.js
var Alert = __webpack_require__(34950);
// EXTERNAL MODULE: ./components/search/SearchTable.js
var SearchTable = __webpack_require__(43928);
;// CONCATENATED MODULE: ./components/columns/CustomerService/CustomerReportColumns.js
/** @format */ 

var columns = [
    {
        dataField: "id",
        text: "No",
        sort: true,
        align: "center",
        headerAlign: "center",
        formatter: function(cellContent, row, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: index + 1
            });
        },
        style: {
            fontSize: "13px",
            color: "#888"
        },
        headerStyle: function() {
            return {
                width: "10%"
            };
        }
    },
    {
        dataField: "status",
        text: "상태",
        sort: true,
        align: "center",
        headerAlign: "center",
        style: {
            fontSize: "13px",
            fontWeight: "bold",
            color: "#f96868"
        },
        headerStyle: function() {
            return {
                width: "15%"
            };
        }
    },
    {
        dataField: "title",
        text: "제목",
        sort: true,
        align: "start",
        headerAlign: "center",
        formatter: function(cellContent) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "truncate-2-lines",
                children: cellContent
            });
        },
        style: {
            fontSize: "13px",
            color: "#333",
            lineHeight: "1.7"
        },
        headerStyle: function() {
            return {
                width: "50%"
            };
        }
    },
    {
        dataField: "createdAt",
        text: "작성일",
        sort: true,
        align: "right",
        headerAlign: "center",
        style: {
            fontSize: "12px",
            color: "#333",
            lineHeight: "1.7"
        },
        headerStyle: function() {
            return {
                width: "25%"
            };
        }
    }, 
];

// EXTERNAL MODULE: ./components/ProjectFirestore.js
var ProjectFirestore = __webpack_require__(79794);
// EXTERNAL MODULE: ./components/modal/DeleteModal.js
var DeleteModal = __webpack_require__(99907);
// EXTERNAL MODULE: ./components/modal/ReportModal.js
var ReportModal = __webpack_require__(49957);
;// CONCATENATED MODULE: ./pages/user/customerService/report.js
/** @format */ 





// Table











var Report = function() {
    var settings = (0,stores_settings/* default */.Z)();
    var ref = (0,react.useState)([]), datas = ref[0], setDatas = ref[1];
    var ref1 = (0,react.useState)("all"), tab = ref1[0], setTab = ref1[1];
    var ref2 = (0,react.useState)(true), updateData = ref2[0], setUpdateData = ref2[1];
    var ref3 = (0,react.useState)(false), modalVisible = ref3[0], setModalVisible = ref3[1];
    (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var collectionRef, tempDatas, collectionValue, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!settings.email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    collectionRef = ProjectFirestore/* projectFirestore.collection */.H.collection("users").doc(settings.email).collection("aisoReport");
                    tempDatas = [];
                    return [
                        4,
                        collectionRef.orderBy("createdAt", "desc").get()
                    ];
                case 2:
                    collectionValue = _state.sent();
                    collectionValue.forEach(function(doc) {
                        tempDatas.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, doc.data()), {
                            id: doc.id
                        }));
                    });
                    if (tab === "all") {
                        setDatas(tempDatas);
                    } else {
                        setDatas(tempDatas.filter(function(f) {
                            return f.status === tab;
                        }));
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        tab,
        updateData
    ]);
    // if (!datas || datas.length === 0)
    //   return (
    //     <div className="flex items-center justify-center">
    //       <button type="button" className="btn btn-dark btn-sm ml-3 w-20" onClick={() => setModalShow(true)}>
    //         신고하기
    //       </button>
    //       <DotMenuModal show={modalShow} onHide={() => setModalShow(false)} />
    //     </div>
    //   );
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-table",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_table2_toolkit_lib/* default */.ZP, {
                keyField: "id",
                bootstrap4: true,
                data: datas,
                columns: columns,
                search: true,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTable/* default */.Z, {
                                    props: props,
                                    size: "col-md-12"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportCategory, {
                                            tab: tab,
                                            setTab: setTab
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "btn btn-danger btn-sm min-w-max font-bold",
                                                onClick: function() {
                                                    return setModalVisible(true);
                                                },
                                                children: "신고하기"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_table2_paginator_lib/* PaginationProvider */.bN, {
                                pagination: (0,react_bootstrap_table2_paginator_lib/* default */.ZP)({
                                    custom: true,
                                    totalSize: datas ? datas.length : 0
                                }),
                                children: function(param) {
                                    var paginationProps = param.paginationProps, paginationTableProps = param.paginationTableProps, datas = param.datas;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "p-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                keyField: "id",
                                                data: datas,
                                                columns: columns,
                                                noDataIndication: " "
                                            }, paginationTableProps, props.baseProps), {
                                                wrapperClasses: "table-responsive",
                                                classes: "mytable-hover2 border-table",
                                                rowClasses: "mytable-hover-row2",
                                                expandRow: {
                                                    showExpandColumn: true,
                                                    expandColumnPosition: "right",
                                                    expandHeaderColumnRenderer: function(param) {
                                                        var isAnyExpands = param.isAnyExpands;
                                                        if (isAnyExpands) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                className: "cursor-pointer border py-1 px-2 rounded-full",
                                                                children: "-"
                                                            });
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            className: "cursor-pointer border py-1 px-2 rounded-full",
                                                            children: "+"
                                                        });
                                                    },
                                                    expandColumnRenderer: function(param) {
                                                        var expanded = param.expanded;
                                                        if (expanded) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                className: "cursor-pointer bg-red-100 py-1 px-2.5 rounded-full text-danger",
                                                                children: "-"
                                                            });
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            className: "cursor-pointer bg-blue-100 py-1 px-2 rounded-full text-primary",
                                                            children: "+"
                                                        });
                                                    },
                                                    renderer: function(datas) {
                                                        return DetailContent(updateData, setUpdateData, (0,_object_spread/* default */.Z)({}, datas));
                                                    }
                                                }
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between items-center w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_table2_paginator_lib/* PaginationListStandalone */.yJ, (0,_object_spread/* default */.Z)({}, paginationProps)),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-end",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_table2_paginator_lib/* PaginationTotalStandalone */.NJ, (0,_object_spread/* default */.Z)({}, paginationProps))
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModalContent, {
                modalVisible: modalVisible,
                closeModal: function() {
                    return setModalVisible(false);
                },
                updateData: updateData,
                setUpdateData: setUpdateData
            })
        ]
    });
};
var ReportModalContent = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, updateData = param.updateData, setUpdateData = param.setUpdateData;
    var settings = (0,stores_settings/* default */.Z)();
    var ref = (0,react.useState)(""), title = ref[0], setTitle = ref[1];
    var ref1 = (0,react.useState)(""), content = ref1[0], setContent = ref1[1];
    var handleModalOkButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var date, createdAt, text, text1, status, email, values, _tmp, collectionRefAiso, newDoc, docRefUser, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = new Date();
                        createdAt = (0,FormatDate/* FormatDate */.r2)(date);
                        if (title === "") {
                            text = "신고 제목을 입력해주세요.";
                            (0,Alert/* BasicAlert */.N)(text);
                            return [
                                2
                            ];
                        }
                        if (content === "") {
                            text1 = "신고 내용을 입력해주세요.";
                            (0,Alert/* BasicAlert */.N)(text1);
                            return [
                                2
                            ];
                        }
                        status = "대기중";
                        email = settings.email;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        _tmp = {};
                        values = (_tmp.title = title, _tmp.content = content, _tmp.createdAt = createdAt, _tmp.email = email, _tmp.status = status, _tmp.answer = "", _tmp.answeredAt = "", _tmp);
                        return [
                            4,
                            ProjectFirestore/* projectFirestore.collection */.H.collection("customerService").doc("report").collection("items")
                        ];
                    case 2:
                        collectionRefAiso = _state.sent();
                        return [
                            4,
                            collectionRefAiso.add(values)
                        ];
                    case 3:
                        newDoc = _state.sent();
                        return [
                            4,
                            ProjectFirestore/* projectFirestore.collection */.H.collection("users").doc(email).collection("aisoReport").doc(newDoc.id)
                        ];
                    case 4:
                        docRefUser = _state.sent();
                        return [
                            4,
                            docRefUser.set(values)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            setUpdateData(!updateData)
                        ];
                    case 6:
                        _state.sent();
                        setTitle("");
                        setContent("");
                        closeModal();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        (0,Alert/* BasicAlert */.N)("신고 등록 실패");
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInit = function() {
        setTitle("");
        setContent("");
        closeModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModal/* default */.Z, {
        modalVisible: modalVisible,
        closeModal: handleInit,
        handleModalOkButton: handleModalOkButton,
        title: title,
        setTitle: setTitle,
        content: content,
        setContent: setContent
    });
};
{
/* 카테고리 선택 */ }var ReportCategory = function(param) {
    var tab = param.tab, setTab = param.setTab;
    var tabClick = function(value) {
        setTab(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full mb-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex items-center m-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "nav-link category-simple-menu ".concat(tab === "all" ? "active" : ""),
                        onClick: function() {
                            return tabClick("all");
                        },
                        children: "전체"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "category-simple-menu-line",
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "nav-link category-simple-menu ".concat(tab === "답변완료" ? "active" : ""),
                        onClick: function() {
                            return tabClick("답변완료");
                        },
                        children: "답변완료"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "category-simple-menu-line",
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "nav-link category-simple-menu no-content ".concat(tab === "대기중" ? "active" : ""),
                        onClick: function() {
                            return tabClick("대기중");
                        },
                        children: "대기중"
                    })
                })
            ]
        })
    });
};
var DetailContent = function(updateData, setUpdateData, param) {
    var id = param.id, title = param.title, email = param.email, content = param.content, createdAt = param.createdAt, answer = param.answer, answeredAt = param.answeredAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportContent, {
        id: id,
        email: email,
        title: title,
        content: content,
        createdAt: createdAt,
        answer: answer,
        answeredAt: answeredAt,
        updateData: updateData,
        setUpdateData: setUpdateData
    });
};
/* 신고 내용 */ var ReportContent = function(param) {
    var id = param.id, email = param.email, title = param.title, content = param.content, createdAt = param.createdAt, answer = param.answer, answeredAt = param.answeredAt, updateData = param.updateData, setUpdateData = param.setUpdateData;
    var ref = (0,react.useState)(false), deleteModalVisible = ref[0], setDeleteModalVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full px-5 mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-danger font-bold mb-3",
                        children: "신고 내용"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-3 px-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "w-full mb-0 text-333 text-base break-words leading-5 font-bold",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full mb-0 text-333 text-base break-words leading-5 mt-3",
                                dangerouslySetInnerHTML: {
                                    __html: content
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 text-888 mt-3",
                                children: createdAt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3 text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btn-outline-grayDanger text-xs p-2 font-bold",
                                    onClick: function() {
                                        return setDeleteModalVisible(true);
                                    },
                                    children: "신고 취소"
                                })
                            })
                        ]
                    }),
                    answeredAt ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full pt-3 border-t border-gray-300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-primary font-bold mb-3",
                                children: "답글"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full mb-0 text-333 text-base break-words leading-5",
                                        children: answer
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0 text-888 mt-3",
                                        children: answeredAt
                                    })
                                ]
                            })
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportDeleteModal, {
                id: id,
                email: email,
                deleteModalVisible: deleteModalVisible,
                setDeleteModalVisible: setDeleteModalVisible,
                updateData: updateData,
                setUpdateData: setUpdateData
            })
        ]
    });
};
/* Report 삭제 모달 */ var ReportDeleteModal = function(param) {
    var id = param.id, email = param.email, deleteModalVisible = param.deleteModalVisible, setDeleteModalVisible = param.setDeleteModalVisible, updateData = param.updateData, setUpdateData = param.setUpdateData;
    var handleReportRemove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var docRefAiso, docRefUser, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            ProjectFirestore/* projectFirestore.collection */.H.collection("customerService").doc("report").collection("items").doc(id)
                        ];
                    case 1:
                        docRefAiso = _state.sent();
                        return [
                            4,
                            ProjectFirestore/* projectFirestore.collection */.H.collection("users").doc(email).collection("aisoReport").doc(id)
                        ];
                    case 2:
                        docRefUser = _state.sent();
                        return [
                            4,
                            docRefAiso.delete()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            docRefUser.delete()
                        ];
                    case 4:
                        _state.sent();
                        setUpdateData(!updateData);
                        setDeleteModalVisible(false);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        (0,Alert/* BasicAlert */.N)("삭제 에러");
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReportRemove() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal/* default */.Z, {
        modalVisible: deleteModalVisible,
        closeModal: function() {
            return setDeleteModalVisible(false);
        },
        handleDeleteOkModal: handleReportRemove,
        target: "내용을"
    });
};
/* harmony default export */ var report = (Report);


/***/ })

}]);